import { useEffect, useState } from 'react';

import { VStack } from '../VStack';
import { KeyboardArrowRight } from '../asset';
import style from './style';

type VListItemProps<T> = {
  list: T[];
  title?: string;
  value?: T;
  onChange?: (item: T) => void;
  onItemClick?: (item: T) => void;
};

const VListItem = <
  T extends { id: any; name: string; len?: number; [key: string]: any },
>({
  list,
  title,
  value,
  onChange,
  onItemClick,
}: VListItemProps<T>) => {
  const [innerSelectedItem, setInnerSelectedItem] = useState<Nullish<T>>(value);

  useEffect(() => {
    if (!innerSelectedItem) return;

    onChange?.(innerSelectedItem);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [innerSelectedItem]);

  return (
    <VStack gap={0.75} className={style.listItem}>
      {title && <div className={style.listItemTitle}>{title}</div>}

      <div className={style.itemListContainer}>
        {list.map(item => {
          const isSelected = innerSelectedItem?.id === item.id;

          return (
            <button
              key={item.id}
              className={style.itemContainer}
              aria-pressed={isSelected}
              type="button"
              onClick={() => {
                setInnerSelectedItem(item);
                onItemClick?.(item);
              }}
            >
              <div className={style.itemInfo}>
                <div className={style.itemName}>{item.name}</div>
                {item.len && <div className={style.itemNum}>{item.len}</div>}
              </div>

              {isSelected && <KeyboardArrowRight className={style.icon} />}
            </button>
          );
        })}
      </div>
    </VStack>
  );
};

export default VListItem;
